import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'liquidacionescomercio',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate(),
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/resumen/liquidacion/comercios?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      "orderCellsTop": true,
      "fixedHeader": true
    });
    $('.box').boxWidget();
  },
  methods: {
    consultar() {
      this.loading = true
      this.tbv.clear()
      this.$http
        .post('/reportes/resumen/liquidacion/comercios', this.f_c)
        .then(response => {
          this.ventast_tabla = 0
          if (response.data.status === 1) {
            response.data.data.forEach(element => {
              for (let d = 3; d < element.length; d++) {
                element[d] = this.num_to_many(element[d])
              }
              this.tbv.row.add(element)
            });
          }
          this.tbv.draw()
          this.loading = false
        })
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/liquidacionesComercios/index.js